/// <amd-module name="Analytics/Boards/VelocityQueries/MetastateByIterationsQuery" />
import { AggregationMode, Metastate, ModefulValueSetting } from "Analytics/Boards/BoardsQueries/DataContracts";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { QueryUtilities } from "Analytics/Common/Utilities/QueryUtilities";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";
import { VelocityDataHelper } from "./VelocityDataHelper";
import { VelocityQueryBase } from "./VelocityQueryBase";

// Analogous to Tfs/Service/WebAccess/Widgets/Scripts/Velocity/Queries/MetastateByIterationsQuery.ts
export class MetastateByIterationsQuery extends VelocityQueryBase<Metastate[]> {
    private static generateQueryOptions(
        projectId: string,
        teamId: string,
        iterationIds: string[],
        aggregation: ModefulValueSetting<AggregationMode, string>,
        workItemTypes: string[]
    ): ODataQueryOptions {
        // $apply
        const iterationsClause = QueryUtilities.isInArray("IterationSK", iterationIds);
        const workItemTypeClause = QueryUtilities.isInArray("WorkItemType", workItemTypes, true /* useQuotes */);

        let $apply =
            `filter(` +
            `Teams/any(t:t/TeamSK eq ${teamId})` +
            ` and (${workItemTypeClause})` +
            ` and (${iterationsClause})` +
            ` and StateCategory ne null`;

        $apply += `)/groupby((StateCategory, State, IterationSK),${VelocityDataHelper.getQueryAggregation(aggregation)})`;

        return {
            entityType: "WorkItems",
            oDataVersion: latestODataVersion,
            project: projectId,
            $apply: $apply
        };
    }
    private queryName?: string;

    constructor(
        command: string,
        projectId: string,
        teamId: string,
        iterationIds: string[],
        aggregation: ModefulValueSetting<AggregationMode, string>,
        workItemTypes: string[],
        queryName?: string
    ) {
        super(command, MetastateByIterationsQuery.generateQueryOptions(projectId, teamId, iterationIds, aggregation, workItemTypes));
        this.queryName = queryName;
    }

    public getQueryName(): string {
        return this.queryName || "MetastateByIterationsQuery";
    }

    protected interpretQueryResults(data: { value: Metastate[] }): Metastate[] {
        // This null filter is only needed because we don't include a 'ne null' filter for effort in the query.
        // As of this writing the reason we don't include it in the query is to get better SQL perf.
        // That may or may not change in the future.
        return data.value.filter(metastate => metastate.AggregationResult != null);
    }
}
